/* eslint-disable no-extend-native */

import moment from "moment";

declare global {
	interface Date {
		toWSDateFormat(): string;
		toFormattedDateString(format: string): string;
		toTextWeekday(firstCharUppercase: boolean): string;
		getMonday(): Date;
	}
}
const dateWSPattern: string = "YYYY-MM-DDTHH:mm:ss";

Date.prototype.toWSDateFormat = function (): string {
	let date = new Date(+this);
	return date.toFormattedDateString(dateWSPattern);
};

Date.prototype.toFormattedDateString = function (format: string): string {
	let date = new Date(+this);
	return moment(date).format(format);
};

Date.prototype.toTextWeekday = function (firstCharUppercase: boolean): string {
	let momdate = moment(this);
	let textWeekday = momdate.format("dddd");
	if (firstCharUppercase) {
		let firstCharToUpper = textWeekday.charAt(0).toUpperCase();
		let otherLetters = textWeekday.slice(1);
		textWeekday = `${firstCharToUpper}${otherLetters}`;
	}
	return textWeekday;
};


Date.prototype.getMonday = function (): Date {
	let date = new Date(+this);
	var day = date.getDay(),
		diff = date.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
	return new Date(date.setDate(diff));
};

export {};
